import Vue from 'vue';

const eventBuses = {};

export function getEventBus(groupId) {
  if (!eventBuses[groupId]) {
    eventBuses[groupId] = new Vue();
  }
  return eventBuses[groupId];
}
